<footer class="drawer-footer-border">
  <div class="footer-content-wrapper">
    <div class="footer-content-left">
      <span *ngIf="subscriberAgreementUrl">
        <a
          id="subscriber-agreement-link"
          target="_blank"
          rel="noopener noreferrer"
          class="color-primary"
          href="{{ subscriberAgreementUrl }}"
          ><button aur-button importance="ghost">
            {{ translations.subscriberAgreement }}
          </button></a
        >
      </span>
      <button
        *ngIf="showContactInformation"
        id="contactInformationButton"
        aur-button
        importance="ghost"
        (click)="contactInformationPanel.toggle($event)"
        (mouseover)="contactInformationPanel.show($event)"
      >
        {{ translations.contactInformation }}
      </button>
      <p-overlayPanel aurPopover #contactInformationPanel>
        <ng-template pTemplate="content">
          <div class="popover-header">
            {{ translations.contactInformation }}
          </div>
          <div class="popover-body" [innerHtml]="contactInformation"></div>
        </ng-template>
      </p-overlayPanel>
    </div>
    <div class="footer-content-right">
      <div *ngIf="!currentStep">
        <button
          *ngIf="sessionCompleteUrl || sessionExitUrl"
          id="col-session-exit-back-btn"
          type="button"
          aur-button
          (click)="onSessionExitClicked()"
          importance="secondary"
        >
          {{ translations.back }}
        </button>
      </div>
      <div *ngIf="currentStep == checkoutStep.PaymentDetails">
        <button
          *ngIf="sessionCompleteUrl || sessionExitUrl"
          id="col-session-exit-back-btn"
          type="button"
          aur-button
          (click)="onSessionExitClicked()"
          importance="secondary"
        >
          {{ translations.back }}
        </button>
        <button
          *ngIf="!hasPayOtherAmountThrownAnError"
          id="col-proceed-to-payment"
          type="submit"
          data-dd-action-name="Proceed to Payment"
          aur-button
          (click)="onProceedToPaymentClicked()"
        >
          {{ translations.proceedToPayment }}
        </button>
      </div>
      <div *ngIf="currentStep == checkoutStep.PaymentType">
        <button
          id="col-payment-type-back-btn"
          type="button"
          aur-button
          (click)="onBackFromSelectPaymentTypeClicked()"
          importance="secondary"
        >
          {{ translations.back }}
        </button>
      </div>
      <div *ngIf="currentStep == checkoutStep.PaymentMethod">
        <button
          id="col-payment-method-back-btn"
          type="button"
          aur-button
          (click)="onBackFromSelectPaymentMethodClicked()"
          importance="secondary"
        >
          {{
            isAlternativePaymentMethodAvailable
              ? translations.alternativePaymentMethod
              : translations.back
          }}
        </button>
        <button
          *ngIf="!hasPayOtherAmountThrownAnError"
          id="col-review-payment"
          type="submit"
          data-dd-action-name="Proceed to Review"
          aur-button
          (click)="onReviewPaymentClicked()"
        >
          {{ translations.reviewPayment }}
        </button>
      </div>
      <div *ngIf="currentStep == checkoutStep.Review">
        <button
          id="col-review-back-btn"
          type="button"
          aur-button
          (click)="onBackFromReviewPaymentClicked()"
          importance="secondary"
        >
          {{ translations.back }}
        </button>
        <button
          id="payment-authorize-payment"
          type="button"
          aur-button
          (click)="onAuthorizePaymentClicked()"
          [disabled]="false"
        >
          {{ translations.authorizePayment }}
        </button>
      </div>
      <div
        *ngIf="
          currentStep == checkoutStep.Confirmation ||
          currentStep == checkoutStep.Pending
        "
      >
        <button
          *ngIf="paymentSucceeded"
          id="print-confirmation"
          aur-button
          type="button"
          (click)="onPrintConfirmationClicked()"
          importance="secondary"
        >
          {{ translations.printConfirmation }}
        </button>
        <button
          id="return-to-app"
          *ngIf="sessionCompleteUrl"
          aur-button
          type="button"
          importance="primary"
          (click)="onReturnToAppClicked()"
        >
          {{ translations.return }}
        </button>
      </div>
    </div>
  </div>
</footer>
